// components/dashboard/DashboardSidebar.js
import React from 'react';

const DashboardSidebar = ({
                              sidebarCollapsed,
                              activeTab,
                              activeSubTab,
                              ppslogo,
                              userName,
                              onToggleSidebar,
                              onSetActiveTab,
                              onSetActiveSubTab,
                              onLogout
                          }) => {
    const menuItems = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: 'fas fa-home',
            subTabs: []
        },
        {
            id: 'nira',
            label: 'NIRA Integration',
            icon: 'fas fa-id-card',
            subTabs: ['register', 'config', 'logs', 'stats']
        },
        {
            id: 'stanbic',
            label: 'Stanbic Integration',
            icon: 'fas fa-university',
            subTabs: ['register', 'config', 'logs']
        },
        {
            id: 'stanchart',
            label: 'SCB Integration',
            icon: 'fas fa-building',
            subTabs: ['register', 'config', 'logs']
        },
        {
            id: 'oauth-clients',
            label: 'OAuth Clients',
            icon: 'fas fa-key',
            subTabs: []
        },
        {
            id: 'smtp-setup',
            label: 'SMTP Setup',
            icon: 'fas fa-envelope',
            subTabs: []
        },
        {
            id: 'notification-templates',
            label: 'Notification Templates',
            icon: 'fas fa-bell',
            subTabs: []
        }
    ];

    return (
        <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-header">
                <div className="logo-container">
                    <img src={ppslogo} alt="PPS Logo" className="sidebar-logo" />
                </div>
                {!sidebarCollapsed && <h2>PPS Dashboard</h2>}
                <button className="sidebar-toggle" onClick={onToggleSidebar}>
                    <i className={`fas ${sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
                </button>
            </div>

            {!sidebarCollapsed && (
                <div className="user-profile">
                    <div className="user-avatar">
                        <i className="fas fa-user-circle"></i>
                    </div>
                    <div className="user-info">
                        <div className="user-name">{userName}</div>
                        <div className="user-role">Administrator</div>
                    </div>
                </div>
            )}

            <div className="sidebar-menu">
                {menuItems.map((item) => (
                    <div key={item.id} className="menu-item-wrapper">
                        <div
                            className={`menu-item ${activeTab === item.id ? 'active' : ''}`}
                            onClick={() => {
                                onSetActiveTab(item.id);
                                if (item.subTabs.length > 0) {
                                    onSetActiveSubTab(item.subTabs[0]);
                                }
                            }}
                        >
                            <i className={item.icon}></i>
                            {!sidebarCollapsed && <span>{item.label}</span>}
                            {!sidebarCollapsed && item.subTabs.length > 0 && (
                                <i className={`fas fa-chevron-down submenu-indicator ${activeTab === item.id ? 'open' : ''}`}></i>
                            )}
                        </div>

                        {!sidebarCollapsed && activeTab === item.id && item.subTabs.length > 0 && (
                            <div className="submenu">
                                {item.subTabs.map((subTab) => (
                                    <div
                                        key={subTab}
                                        className={`submenu-item ${activeSubTab === subTab ? 'active' : ''}`}
                                        onClick={() => onSetActiveSubTab(subTab)}
                                    >
                                        <i className="fas fa-circle"></i>
                                        <span>{subTab.charAt(0).toUpperCase() + subTab.slice(1)}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="sidebar-footer">
                <div className="menu-item" onClick={onLogout}>
                    <i className="fas fa-sign-out-alt"></i>
                    {!sidebarCollapsed && <span>Logout</span>}
                </div>
            </div>
        </div>
    );
};

export default DashboardSidebar;